<template>
  <a v-if="hasLink && url" :href="url" target="_blank">
    <span v-html="label" class="employee-map-link-label"></span>
  </a>
  <b-btn
    v-else-if="hasPlaceOnMapButton && canPlaceOnMap"
    class="employee-map-link-label"
    variant="default"
    size="sm"
    @click="$emit('placeOnMap', item)"
    >Place on Map</b-btn
  >
  <span v-else v-html="label" class="employee-map-link-label"></span>
</template>

<script>
import { POINT_ICONS } from '@/store/modules/point'
import { mapState, mapGetters } from 'vuex'
import { canManageEmployeeDeskEvents } from '@/utils/DeskEventOwnership'

export default {
  name: 'EmployeeMapLinkCell',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('rbac', ['canBookForOthers']),
    hasPlaceOnMapButton() {
      return (!this.user.booking_enabled && !this.hasLink) || !this.label
    },
    canPlaceOnMap() {
      return canManageEmployeeDeskEvents(this.item, this.user, this.canBookForOthers)
    },
    infinityDeskEvent() {
      return (this.item.events ?? []).find((event) => event.end === 'infinity')
    },
    activeDeskEvent() {
      return (this.item.events ?? []).find((event) => event.desk.point.icon_id === POINT_ICONS.DESK_BUSY)
    },
    hasLink() {
      return (this.user.booking_enabled && this.activeDeskEvent) || this.infinityDeskEvent
    },
    url() {
      const point = (this.infinityDeskEvent || this.activeDeskEvent)?.desk?.point
      return point ? `/map/${point.floor_id}?pointId=${point.id}&edit=true` : ''
    },
    label() {
      if (this.infinityDeskEvent) {
        return '<span class="infinity-link">&infin;</span>'
      }
      if (this.activeDeskEvent) {
        return 'active'
      }
      if (this.item.events?.length) {
        // todo: add some search link on map in this case
        return `${this.item.events?.length} booking${this.item.events?.length > 1 ? 's' : ''}`
      }
      return ''
    }
  }
}
</script>

<style>
.infinity-link {
  font-size: 160%;
}

.employee-map-link-label {
  white-space: nowrap;
}
</style>
